/**
 * Now-playing domain — the single track currently active in the server's
 * playback state. Mirrored to the Discord bot presence.
 */
import { z } from "zod";
export const NowPlayingSchema = z.object({
    id: z.number().int().nonnegative(),
    title: z.string(),
    artist: z.string().nullable(),
    owner: z.string(),
    durationSec: z.number().positive().nullable(),
    index: z.number().int().nonnegative(),
    queueLength: z.number().int().nonnegative(),
});
export const PutNowPlayingBodySchema = z.object({
    id: z.number().int().nonnegative(),
    index: z.number().int().nonnegative(),
    queueLength: z.number().int().nonnegative(),
    durationSec: z.number().positive().optional(),
});
export const ReportTimeBodySchema = z.object({
    currentTime: z.number().nonnegative(),
});
export const EndSessionBodySchema = z.object({
    listenedSeconds: z.number().nonnegative().optional(),
});
//# sourceMappingURL=nowPlaying.js.map